import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=0a527673&scoped=true&"
import script from "./Roulette.vue?vue&type=script&lang=js&"
export * from "./Roulette.vue?vue&type=script&lang=js&"
import style0 from "./Roulette.vue?vue&type=style&index=0&id=0a527673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a527673",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFadeTransition,VImg,VRow})
